export default {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  SEARCH: 'search',
  ICF: 'guide',
};
